import { closeModal } from 'components/modal/modules/dispatcher/methods';
import { RouteTo } from 'lib/utils/routing';
import React from 'react';
import { withRouter } from "react-router-dom";
import { fetchGraphQL } from 'services/graphql/GraphQL';

import { purchase } from '../../../components/graphql/queries/ticket';

class InternationalCardModal extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.state = {
            purchasing: false
        }
        this.purchase = this.purchase.bind(this);
    }

    public async purchase(fee: any) {
        this.props.ticketComponents.forEach(item => {
            delete item.price;
        });

        this.setState({ purchasing: true })
        const purchaseResult = await fetchGraphQL(purchase(), undefined, {
            ticketComponents: this.props.ticketComponents,
            ticketCode: this.props.ticketCode !== null && this.props.ticketCode !== undefined ? this.props.ticketCode : undefined,
            stripeToken: this.props.stripeToken,
            eventId: this.props.eventId,
            buyer: this.props.buyer,
            promoterId: this.props.promoterId !== null && this.props.promoterId !== undefined ? this.props.promoterId : undefined,
            internationalCardConversionFee: String(fee)
        });
        this.setState({ purchasing: false })

        if (
            purchaseResult !== undefined &&
            purchaseResult.ticket !== undefined &&
            purchaseResult.ticket.purchase !== null &&
            purchaseResult.ticket.purchase !== 'PAYMENT_ERROR' &&
            purchaseResult.ticket.purchase !== 'NQUOTA' &&
            purchaseResult.ticket.purchase !== 'BOUGHT' &&
            purchaseResult.ticket.purchase !== 'NMATCH' &&
            purchaseResult.ticket.purchase !== 'RES_EMAIL'
        ) {
            this.props.history.push(
                RouteTo.ticketPublic(purchaseResult.ticket.purchase)
            );
            closeModal()

        } else {
            this.setState({
                purchaseError: true,
                errorMsg: purchaseResult.ticket.purchase || 'NMATCH'
            });
        }
        this.props.resetCharging();

    }

    public render() {

        let subtotal = 0;
        let totalCount = 0;

        const absorb = this.props.fees.absorb;
        const perTicketFee = this.props.fees.perTicketFee;

        this.props.ticketComponents.map(item => {
            subtotal += item.count * item.price
            totalCount += item.count;
        })

        const perOrderAndSubtotal = subtotal * (1 + (this.props.fees.perOrderFee) / 100);
        const total = absorb ? (subtotal) : (perOrderAndSubtotal + (totalCount * perTicketFee * 100));
        const extraCharge = ((total + 30) / 0.961) - ((total + 30) / 0.971);

        return <div>
            An international card has been detected. An extra transaction fee of ${(extraCharge / 100).toFixed(2)} will be added to the bank processing fees. Click purchase to continue.
            <hr />
            <div className="Seperate-Buttons">
                {
                    this.state.purchasing ? null :
                        <button
                            className='new-button-white-3'
                            style={{
                                border: 'none'
                            }}
                            onClick={e => window.location.reload()}
                        >
                            CANCEL
                        </button>
                }

                <button
                    className='new-button-white-3'
                    style={{
                        border: 'none'
                    }}
                    onClick={e => this.purchase((extraCharge / 100).toFixed(2))}
                    disabled={this.state.purchasing}
                >
                    {this.state.purchasing ? 'PURCHASING...' : 'PURCHASE'}
                </button>
            </div>
        </div>
    }

}

export default withRouter(InternationalCardModal);


// WEBPACK FOOTER //
// ./src/pages/event/public/InternationalCardModal.tsx